import { Link } from "react-router-dom";

interface SectionHeadingProps {
  title: string;
  subtitle?: string;
  moreTo?: string;
  moreLabel?: string;
}

export default function SectionHeading({
  title,
  subtitle,
  moreTo,
  moreLabel = "查看更多",
}: SectionHeadingProps) {
  return (
    <div className="flex items-end justify-between gap-4 mb-5 md:mb-7">
      <div className="flex items-start gap-3">
        <span className="w-1.5 h-7 md:h-8 rounded-full bg-accent-500 mt-0.5 shrink-0"></span>
        <div>
          <h2 className="font-heading text-xl md:text-2xl font-bold text-foreground-950 leading-tight">
            {title}
          </h2>
          {subtitle && (
            <p className="mt-1.5 text-xs md:text-sm text-foreground-500">{subtitle}</p>
          )}
        </div>
      </div>

      {moreTo && (
        <Link
          to={moreTo}
          className="shrink-0 inline-flex items-center gap-1 text-xs md:text-sm text-foreground-600 hover:text-accent-400 transition-colors whitespace-nowrap cursor-pointer"
        >
          {moreLabel}
          <i className="ri-arrow-right-s-line text-base"></i>
        </Link>
      )}
    </div>
  );
}